import type * as React from 'react';
import { get } from '@Domain/Api';
import accountFacilitiesFetched, {
	type AccountFacilitiesFetchedAction,
	type AccountFacilitiesFetchedPayload,
} from '@Application/Facilities/Facilities/Actions/accountFacilitiesFetched';
import accountFacilitiesFetchFailed, {
	type AccountFacilitiesFetchFailedAction,
} from '@Application/Facilities/Facilities/Actions/accountFacilitiesFetchFailed';
import type FetchAccountFacilities from '@Application/Facilities/Facilities/Queries/FetchAccountFacilities';
import ApiError from '@Infra/FetchLib/ApiError';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AccountFacilitiesFetchedAction | AccountFacilitiesFetchFailedAction;

// `.../accounts/{id}/facilities` answers a bare array, sorted by `name` server-side — not the
// `{ totalRecords, results }` envelope of a paginated resource, hence `get` rather than `getPaginated`.
export default (query: FetchAccountFacilities) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<AccountFacilitiesFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/facilities`,
			);

			const action = accountFacilitiesFetched(response, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const status = error instanceof ApiError ? error.status : null;
			const action = accountFacilitiesFetchFailed(extractMessages(error), status);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
